console.log("Recommendation Matrix Loaded");

const REQUIREMENT_MATRIX = {

    home: [
        "INDOOR",
        "BULB"
    ],

    apartment: [
        "INDOOR",
        "BULB"
    ],

    office: [
        "INDOOR"
    ],

    shop: [
        "OUTDOOR",
        "PTZ",
        "BULLET"
    ],

    warehouse: [
        "PTZ",
        "OUTDOOR",
        "4G"
    ],

    garden: [
        "OUTDOOR",
        "PTZ",
        "FLOODLIGHT"
    ],

    farm: [
        "OUTDOOR",
        "PTZ",
        "4G"
    ],

    villa: [
        "OUTDOOR",
        "INDOOR",
        "BULB"
    ]

};

function getPreferredSubtypes(requirement){

    return REQUIREMENT_MATRIX[requirement] || [];

}

//================================================
// AUTOMATIC CHAT SCROLL
//================================================

function scrollAssistantToBottom(){

    const chatContainer =
        document.querySelector(
            ".assistant-messages"
        );

    if(!chatContainer){
        return;
    }

    requestAnimationFrame(() => {

        chatContainer.scrollTop =
            chatContainer.scrollHeight;

    });

}

function enableAssistantAutoScroll(){

    const chatContainer =
        document.querySelector(
            ".assistant-messages"
        );

    if(!chatContainer){
        console.warn(
            "Assistant message container not found."
        );

        return;
    }

    const observer =
        new MutationObserver(() => {

            scrollAssistantToBottom();

        });

    observer.observe(
        chatContainer,
        {
            childList: true,
            subtree: true
        }
    );

}